export function propsToInitialState(data, viTriList) {
  const dataInit = { ...data };
  dataInit.hienThi = data?.hienThi === false ? false : true;
  dataInit.viTri = viTriList?.find(item => item?.value === data?.viTri) || null;
  dataInit.order = data?.order || null;
  dataInit.fileImages = data?.fileImage?.file_path
    ? [
        {
          bucket_name: data.fileImage?.bucket_name || null,
          file_path: data.fileImage?.file_path || null,
          file_oid: data.fileImage?.file_oid || 0,
          file_name: data.fileImage?.file_name || null,
          file_ext: data.fileImage?.file_ext || null,
          file_size: data.fileImage?.file_size || 0
        }
      ]
    : null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.viTri = value?.viTri?.value || 0;
  dataSave.order = value?.order || 0;
  dataSave.hienThi = value?.hienThi || false;
  dataSave.fileImage = value?.fileImages?.[0]?.file_path
    ? value?.fileImages?.[0]
    : null;
  return dataSave;
}
